'use client'

import { StickyConnected } from 'components/WebEv/CoverLP2023/Sticky'
import { EnergyBenefitsConnected } from 'components/Phantom/_sections/EnergyBenefits'
import { MakeYourSideYourOwnConnected } from 'components/Phantom/_sections/MakeYourSideYourOwn'
import { NewBaseConnected } from 'components/Pod4NewBase'
import { Pod4ElevateSleep } from 'components/Pod4ElevateSleep'
import { Pod4SeamlessSnoring } from 'components/Pod4SeamlessSnoring'
import { InvisibleComfort } from 'components/Phantom/_sections/Pod4Comfort'
import { BestWayToWakeUp } from 'components/Phantom/_sections/BestWayToWakeUp'
import { NoPhoneConnected } from 'components/Pod4NoPhone'
import { AutopilotFeatures } from 'components/Phantom/_sections/AutopilotFeatures'
import { ClientOnly } from 'components/ClientOnly'
import { SleepAndHealthReportOverview } from 'components/Phantom/_sections/SleepAndHealthReportOverview'
import { ExtraordinaryPeopleStatic } from 'components/Phantom/_sections/ExtraordinaryPeopleStatic'
import Pod4ShopComparison from 'components/Pod4ShopComparison/Pod4ShopComparison'
import { ScrollSequenceStatic } from 'components/Phantom/_sections/ScrollSequenceStatic'
import React, { JSX } from 'react'
import dynamic from 'next/dynamic'
import { HeroConnected } from './components'
// TODO POD5: use new Pod5Hero
//import { HeroConnected } from './components/Pod5Hero'
import { FourColumnBenefits } from 'components/FourColumnBenefits'
import { ProductBreakdownConnected } from 'components/ProductBreakdown'
// TODO Pod5: add Pod5UserStory section
// import { Pod5UserStory } from './components/Pod5UserStory/Pod5UserStory'
const AppOverviewLazy = dynamic(() => import('components/Phantom/_sections/AppOverviewTour').then((module) => module.AppOverviewTour), { ssr: false })

const PodCover = (): JSX.Element => {
	return (
		<div className={'disable-transitions'}>
			<StickyConnected />
			<HeroConnected />
			<FourColumnBenefits />
			<ProductBreakdownConnected theme={'light'} />
			<EnergyBenefitsConnected />
			<MakeYourSideYourOwnConnected />
			<NewBaseConnected />
			<Pod4ElevateSleep />
			<Pod4SeamlessSnoring />
			<InvisibleComfort />
			<BestWayToWakeUp />
			<NoPhoneConnected />
			<AutopilotFeatures />

			<ClientOnly>
				{/*<BetterThanAWearable />*/}
				<SleepAndHealthReportOverview />
				<AppOverviewLazy />
				{/*<LegKitBriefer />*/}

				<ExtraordinaryPeopleStatic />
				<Pod4ShopComparison />
			</ClientOnly>
			<ScrollSequenceStatic />
		</div>
	)
}

export default PodCover
